import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06081727"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-comment-wrapper" }
const _hoisted_2 = { class: "live-comment-item" }
const _hoisted_3 = {
  key: 0,
  class: "comment-text-wrap join-user"
}
const _hoisted_4 = {
  key: 1,
  class: "comment-text-wrap"
}
const _hoisted_5 = {
  key: 0,
  class: "icon-host"
}


import {TimCustomMessageTypeEnum} from 'common/enum';


export default /*#__PURE__*/_defineComponent({
  props: {
    info: null,
    hostUid: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.info.command === _unref(TimCustomMessageTypeEnum).JOIN_USER)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(__props.info.username) + "进入直播间", 1 /* TEXT */)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (__props.hostUid === __props.info.uid)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("v-if", true),
            (__props.info.username)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["comment-username", {'comment-username--host': __props.hostUid === __props.info.uid}])
                }, _toDisplayString(__props.info.username), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(__props.info.msg), 1 /* TEXT */)
          ]))
    ])
  ]))
}
}

})